import { Cancel, Check, Close, Save } from "@mui/icons-material";
import { CircularProgress, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { Formik } from "formik";
import { isEmpty } from "lodash";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Api from "../../api2";
import Helper from "../../helpers";
import { commonReducerSelector, userSelector } from "../../redux/selector";
import {
  MyBreadCrumbs,
  MyButton,
  MyForm,
  MyTable,
  MyTextFieldArea,
  MyThaoTac,
  ThongBao,
  scrollToError
} from "../Lib/componentLibrarys";
import { ValidateSchema } from "./validate";
import { FormNhap } from "./form";
import { parseDataSave, propsToInitialState } from "./models";
import Api_DanhMuc from "../../api_danhmuc";
import { el } from "date-fns/locale";

const RoutesSanPham = [
  {
    path: "",
    main: () => <SanPham />
  },
  {
    path: "add",
    main: () => <HandleSanPham />
  },
  {
    path: "edit/:id",
    main: () => <HandleSanPham />
  },
  {
    path: "detail/:id",
    main: () => <HandleSanPham view={true} />
  }
];
export default RoutesSanPham;

function SanPham() {
  const [dataFormik, setFormik] = useState({
    search: "",
    limit: 10,
    anchor: 0
  });
  const common = useSelector(commonReducerSelector);
  const profile = common?.profile?.data;
  const [rawData, setRawData] = useState({});
  const [Count, setCount] = useState();
  const [data, setData] = useState([]);
  const [openDiaLog, setOpenDiaLog] = useState(false)
  const [submitDiaLog, setSubmitDiaLog] = useState(false)
  const [selectedData, setSelectedData] = useState(null);
  const [lyDo, setLyDo] = useState('')
  const [openDiaLogViewLog, setOpenDiaLogViewLog] = useState(false)
  const [dataLog, setDataLog] = useState([])
  const formikRef = useRef();
  //for table method
  const navigate = useNavigate();

  const parseSearchForm = values => {
    const tuKhoa = values?.search?.length > 0 ? values?.search : "";
    const limit = values?.limit ? values.limit : 10;
    const anchor = values?.anchor ? values.anchor : 0;
    const page = values?.page || "";
    return { tuKhoa, limit, anchor, page };
  };

  useEffect(() => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
  }, []);
  const getRows = (limit, anchor, page) => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm({ ...values, limit, anchor, page }));
  };

  const handleActivate = (data) => {
    setSelectedData(data);
    setOpenDiaLog(true);
  };

  const handleViewLog = (idsanpham) => {
    new Api()
      .GetLogSanPhams({ idsanpham })
      .then((res) => {
        if (res.code === 200 && !isEmpty(res.data)) {
          setDataLog(res.data);
          setOpenDiaLogViewLog(true);
        } else {
          ThongBao({ status: 'error', message: 'Không có dữ liệu log' });
        }
      });
  };

  const handleDetail = (data) => {
    if (!data?.id) {
      ThongBao({ status: "warn", message: "ID không tồn tại" });
      return;
    }
    navigate(`detail/${data?.id || undefined}`);
  }

  useEffect(() => {
    if (submitDiaLog && selectedData) {
      const submitData = {
        id: selectedData?.id,
        lock_Unlock: selectedData?.isLock ? false : true,
        lyDo: lyDo
      };
      new Api()
        .LockSanPham({ data: submitData })
        .then((res) => {
            if (!res || res.code !== 200) {
                ThongBao({ status: 'error', message: 'Đã có lỗi xảy ra' });
                return;
            }
            getApi(parseSearchForm(formikRef.current.values));
            ThongBao({ status: 'success', message: `${selectedData?.isLock ? 'Mở khóa' : 'Khóa' } thành công` });
        })
        .catch((err) => {
            ThongBao({ status: 'error', message: 'Đã có lỗi xảy ra' });
        })
        .finally(() => {
            setSubmitDiaLog(false);
            setSelectedData(null);
        });
    }
  }, [submitDiaLog]);

  const getApi = ({ tuKhoa, limit, anchor, page }) => {
    new Api()
      .GetListSanPham({ tuKhoa, limit, anchor })
      .then(res => {
        if (res.code === 200) {
          setData(
            Helper.addSttToTableDataSource(res.data.records, page, limit)
          );
          setRawData(res.data);
        }
        if (res.data?.count) {
          setCount(res.data?.count);
        }
      })
      .catch(err => {});
  };
  const onSubmitSearch = () => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
  };

  const columns = ({ handleEdit, handleDelete }) => {
    var column = [
      {
        headerName: "STT",
        field: "stt",
        width: "100px",
        suppressSizeToFit: true,
        pinned: "left",
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center"
      },
      { headerName: "Tên sản phẩm", field: "tenSanPham", width: "300px" },
      { headerName: "Mã sản phẩm", field: "maSanPham", width: "180px" },
      {
        headerName: "Khối lượng sản phẩm",
        field: "khoiLuongSanPham",
        width: "250px"
      },
      // { headerName: "Đơn vị tính", field: "donViTinh", width: "200px" },
      {
        headerName: "Năm đăng ký sử dụng",
        field: "namDangKySuDung",
        width: "200px"
      },
      {
        headerName: "Tình trạng hoạt động",
        width: "200px",
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center",
        cellRendererFramework: params => {
          let returnStatus = (
            <div className="tableList-button-ngungHoatDong">Dừng hoạt động</div>
          );
          if (params?.data?.tinhTrangHoatDong === true) {
            returnStatus = (
              <div className="tableList-button-dangHoatDong">
                Đang hoạt động
              </div>
            );
          }
          return returnStatus;
        }
      },
      {
        headerName: "Trạng thái khóa",
        minWidth: 200,
        flex: 1,
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center",
        cellRendererFramework: params => {
          let returnStatus = (
            <div className="tableList-button-dangHoatDong">
              Bình thường
            </div>
          );
          if (params?.data?.isLock === true) {
            returnStatus = (
              <div className="tableList-button-ngungHoatDong">Đang bị khóa</div>
            );
          }
          return returnStatus;
        }
      },
      {
        headerName: "Thao tác",
        width: "100px",
        pinned: "right",
        cellStyle: { justifyContent: "center" },
        cellRendererFramework: prams => (
          <MyThaoTac
            prams={prams}
            handleEdit={profile?.cap !== 0 && handleEdit}
            handleActivate={profile?.cap === 0 && handleActivate}
            isActivated={!prams?.data?.isLock}
            handleDetail={handleDetail}
            handleViewLog={handleViewLog}
          />
        ),
        headerClass: "ag-grid-header-center"
      }
    ];
    return column;
  };

  const handleEdit = params => {
    if (!params?.id) {
      ThongBao({ status: "warn", message: "ID không tồn tại" });
    }
    navigate(`edit/${params?.id || undefined}`);
  };
  const handleAdd = data => {
    navigate(`add`);
  };
  const handleDelete = params => {
    new Api()
      .DeleteSanPhamById({ id: params?.id })
      .then(res => {
        if (res.code === 200) {
          const values = formikRef.current.values;
          getApi(parseSearchForm(values));
          ThongBao({ status: "success", message: "Xóa thành công" });
        }
      })
      .catch(err => {});
  };

  return (
    <div className="divMain">
      <MyBreadCrumbs title={[{ name: "Vận hành" }, { name: "Sản phẩm" }]} />
      <MyForm
        formikRef={formikRef}
        showSearch={true}
        dataFormik={dataFormik}
        handleAdd={handleAdd}
        editable={true}
        onSubmitAPI={onSubmitSearch}
        marginBottom={"15px"}
        cannotCreate={profile?.cap === 0}
      />
      <MyTable
        autofit={true}
        columns={columns({
          editable: true,
          handleEdit: handleEdit,
          handleDelete: handleDelete
        })}
        data={data}
        pagination={{
          rawData: rawData,
          setData: setData,
          getRows: getRows,
          Count: Count
        }}
      />
      <Dialog
        open={openDiaLog} 
        onClose={() => setOpenDiaLog(false)} 
        aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <DialogTitle className="capPhep-listInput-dialog-title" style={{ width: 400 }}>Lý do khóa/mở khóa</DialogTitle>
          <div style={{ marginLeft: 10, marginRight: 10 }}>
            <MyTextFieldArea
              placeholder="Nhập..."
              maxRows={3}
              rows={3}
              value={lyDo}
              onChange={(e) => {
                setLyDo(e?.target?.value)
              }}
            />
          </div>
          <DialogActions className="capPhep-listInput-dialog-content" style={{ display: 'flex', justifyContent: 'center' }}>
              <MyButton onClick={() => setOpenDiaLog(false)} txt="Hủy bỏ" color="rgb(122, 122, 122)" className="capPhep-listInput-dialog-buttonClose" icon={<Close />} />
              <MyButton
                  onClick={() => {
                    setOpenDiaLog(false)
                    setSubmitDiaLog(true)
                  }}
                  txt="Xác nhận"
                  className="capPhep-listInput-dialog-buttonCheck"
                  icon={<Check />}
              />
          </DialogActions>
      </Dialog>

      {/* // Dialog for view log */}
      <Dialog
        open={openDiaLogViewLog}
        onClose={() => setOpenDiaLogViewLog(false)}
        aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description"
        maxWidth={false}
        PaperProps={{
          sx: {
            width: '65vw',
            minWidth: 600,
            maxWidth: '90vw',
            height: '80vh',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
          }
        }}
      >
          <DialogTitle 
            className="capPhep-listInput-dialog-title" 
            style={{ width: '100%', color: '#24408A', fontWeight: 600 }}
          >
            LOGS SẢN PHẨM
          </DialogTitle>
          <div style={{ marginLeft: 20, marginRight: 20, paddingRight: 16, flex: 1, overflowY: 'auto', minWidth: 350 }}>
            {Array.isArray(dataLog) && dataLog.length > 0 ? (
              dataLog.map((log, idx) => {
                // Lấy tất cả key của dữ liệu cũ và mới, loại bỏ các trường không cần so sánh
                const excludeFields = ['moTa', 'hinhAnhDaiDienJson', 'hinhAnhDaiDien', 'hinhAnhJson', 'hinhAnhs'];
                const oldData = log.duLieuCu || {};
                const newData = log.duLieuMoi || {};
                const allKeys = Array.from(new Set([...Object.keys(oldData), ...Object.keys(newData)])).filter(key => !excludeFields.includes(key));
                return (
                  <div key={idx} style={{ border: '1px solid #24408A', borderRadius: 8, marginBottom: 12, padding: 20, background: '#deefffa6' }}>
                    <div style={{ fontWeight: 600, color: '#40A7DE', marginBottom: 4 }}>Lần cập nhật thứ {dataLog.length - idx}</div>
                    <div style={{ fontSize: 13, marginBottom: 2 }}>
                      <b>Ngày sửa:</b> {log.ngaySua || '-'}
                    </div>
                    <div style={{ fontSize: 13, marginBottom: 8 }}>
                      <b>Người sửa:</b> {log.nguoiSua || '-'}
                    </div>
                    <div style={{ fontSize: 13, marginBottom: 2, fontWeight: 700 }}>So sánh thay đổi:</div>
                    <div style={{ overflowX: 'auto' }}>
                      <table style={{ borderCollapse: 'collapse', width: '100%', tableLayout: 'fixed', background: '#fff', fontSize: 13 }}>
                        <colgroup>
                          <col style={{ width: '20%' }} />
                          <col style={{ width: '40%' }} />
                          <col style={{ width: '40%' }} />
                        </colgroup>
                        <thead>
                          <tr style={{ background: '#e3f2fd' }}>
                            <th style={{ border: '1px solid #b3c6e0', padding: '6px 10px', wordBreak: 'break-word', whiteSpace: 'pre-line' }}>Trường</th>
                            <th style={{ border: '1px solid #b3c6e0', padding: '6px 10px', wordBreak: 'break-word', whiteSpace: 'pre-line' }}>Giá trị cũ</th>
                            <th style={{ border: '1px solid #b3c6e0', padding: '6px 10px', wordBreak: 'break-word', whiteSpace: 'pre-line' }}>Giá trị mới</th>
                          </tr>
                        </thead>
                        <tbody>
                          {allKeys.map((key) => {
                            const oldValue = oldData[key];
                            const newValue = newData[key];
                            const isChanged = oldValue !== newValue;
                            return (
                              <tr key={key} style={isChanged ? { background: '#fff9c4' } : {}}>
                                <td style={{ border: '1px solid #b3c6e0', padding: '6px 10px', fontWeight: isChanged ? 600 : 400, wordBreak: 'break-word', whiteSpace: 'pre-line' }}>{key}</td>
                                <td style={{ border: '1px solid #b3c6e0', padding: '6px 10px', color: '#888', wordBreak: 'break-word', whiteSpace: 'pre-line' }}>{oldValue === undefined ? '-' : String(oldValue)}</td>
                                <td style={{ border: '1px solid #b3c6e0', padding: '6px 10px', color: isChanged ? '#d84315' : '#222', fontWeight: isChanged ? 600 : 400, wordBreak: 'break-word', whiteSpace: 'pre-line' }}>{newValue === undefined ? '-' : String(newValue)}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              })
            ) : (
              <div style={{ color: '#888', fontStyle: 'italic', textAlign: 'center', margin: 24 }}>Không có dữ liệu log</div>
            )}
          </div>
          <DialogActions className="capPhep-listInput-dialog-content" style={{ display: 'flex', justifyContent: 'center' }}>
              <MyButton onClick={() => setOpenDiaLogViewLog(false)} txt="Hủy bỏ" color="rgb(122, 122, 122)" className="capPhep-listInput-dialog-buttonClose" icon={<Close />} />
          </DialogActions>
      </Dialog>
    </div>
  );
}

function HandleSanPham({ view }) {
  const navigate = useNavigate();
  const user = useSelector(userSelector);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [data, setData] = useState(null);
  const common = useSelector(commonReducerSelector);
  const profile = common?.profile;
  const dataDanhMuc = common?.danhmucs?.data;
  const [danhMucSanPhamList, setDanhMucSanPhamList] = useState([]);
  const formRef = useRef(null);

  //ref just for use scroll when error validate
  const refI = useRef(null);

  useEffect(() => {
    if (id && !data) {
      setIsLoading(true);
      new Api()
        .GetSanPhamById({ id: id })
        .then(data => {
          if (data.code === 200) {
            setData(data?.data);
          }
        })
        .catch(err => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
    if (isEmpty(danhMucSanPhamList)) {
      new Api_DanhMuc().GetListSanPhams({}).then(data => {
        if (data.code === 200) {
          setDanhMucSanPhamList(data?.data?.records);
        }
      });
    }
  }, [id]);

  if (isLoading) {
    return (
      <div className="style-loading">
        <CircularProgress />
      </div>
    );
  }

  //set initial data
  const initialState = propsToInitialState(data, danhMucSanPhamList);

  //List form
  const formNhap = (
    <Formik
      innerRef={f => (formRef.current = f)}
      i
      initialValues={initialState}
      enableReinitialize={true}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={ValidateSchema}
    >
      {({ values, errors, handleSubmit, setFieldValue }) => (
        <form onSubmit={handleSubmit}>
          {/* div just for use scroll when error validate */}
          <div ref={refI}></div>
          <FormNhap
            view={view}
            values={values}
            errors={errors}
            setFieldValue={setFieldValue}
            danhMucSanPhamList={danhMucSanPhamList}
          />
        </form>
      )}
    </Formik>
  );

  //handle when submit API
  const handleSave = async () => {
    await formRef.current.validateForm();

    if (!isEmpty(formRef.current.errors)) {
      scrollToError(refI);
      ThongBao({
        status: "warn",
        message: "Yêu cầu nhập đầy đủ các trường có dấu đỏ"
      });
      return;
    }

    new Api()
      .UpsertSanPham({
        token: user.access_token,
        data: parseDataSave(formRef.current.values, profile)
      })
      .then(res => {
        if (!res || res.code !== 200) {
          //TODO
          ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
          return;
        }
        ThongBao({ status: "success", message: "Thành công" });
        navigate(-1);
      })
      .catch(err => {
        ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
      })
      .finally(() => {});
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: "0.875rem"
        }}
      >
        <MyBreadCrumbs
          title={[
            { name: "Vận hành" },
            { name: "Sản phẩm", link: -1 },
            { name: `${id ? "Cập nhật " : "Thêm mới"}` }
          ]}
        />
        {formNhap}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 15
        }}
      >
        <MyButton
          onClick={() => navigate(-1)}
          txt="Hủy bỏ"
          color="#888"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Cancel />}
        />
        <p style={{ width: 5 }}></p>
        { !view && (
          <MyButton
            onClick={() => {
              handleSave();
            }}
            txt="Lưu thông tin"
            style={{ width: 130, height: 33, marginTop: 5 }}
            icon={<Save />}
          />
        )}
        
      </div>
    </>
  );
}
